/**
 * 08.10.26 — панель SMS справочника каналов.
 * 05.11.2026 — НЕ УДАЛЯТЬ. Билайн показывается рядом с Intis, токен на страницу не приходит.
 * CROSS-REF: internal/handler/tenant_settings.go getChannelDirectoryResponse
 * Не удалять по требованию владельца системы.
 */
import { ShieldCheck } from 'lucide-react';
import { Input } from '@/components/ui';
import type { ChannelPanelProps } from '../channelPanelProps';
import { ChannelFieldLabel } from './ChannelLink';

export function SmsChannelPanel({ form, isSuperAdmin, onChange }: ChannelPanelProps) {
  return (
    <div className="space-y-4">
      {isSuperAdmin ? (
        <Input
          label="Sender ID"
          value={form.sms_sender_id || ''}
          onChange={(event) => onChange({ sms_sender_id: event.target.value })}
          placeholder="DHC / UlybkaPRO / DoctorPlus"
          testId="input-sms-sender-id"
        />
      ) : (
        <div>
          <ChannelFieldLabel>Sender ID</ChannelFieldLabel>
          <div className="mt-1 text-sm text-shell-text">{form.sms_sender_id || 'Не указан'}</div>
        </div>
      )}
      <div className="space-y-2 rounded-xl border border-shell-border bg-shell-elevated p-4 text-sm text-shell-text">
        <div className="flex items-center gap-2 font-medium">
          <ShieldCheck className="h-4 w-4 text-shell-primary" />
          <span>Важно для коллег</span>
        </div>
        <p>{form.sms_note}</p>
        <p>
          Технический пользователь отправки: <strong>{form.sms_account_name}</strong>
        </p>
        <p>
          Активный провайдер: <strong>{form.sms_provider || 'intis'}</strong>
        </p>
        {form.beeline_configured ? (
          <p>
            Билайн подключён, отправитель <strong>{form.beeline_sender_id || 'не указан'}</strong>.{' '}
            {form.beeline_note}
          </p>
        ) : null}
        {form.sms_tel_line ? (
          <p>
            SMS-Tel идёт через модем OLAX, линия <strong>{form.sms_tel_line}</strong>. Входящие и исходящие этой линии попадают в этот тенант.
          </p>
        ) : null}
      </div>
    </div>
  );
}
